/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { pick } from 'lodash';
export const profileFields = ['firstName', 'lastName', 'phoneNumber'];
/**
 * Check that all profile fields are populated on a UserProfile
 *
 * @param  {ProfileForm} profile
 * @return {boolean} true if the profile has all profileFields populated
 */
export const verifyProfile = profile => {
  const profileData = pick(profile, profileFields);
  return profileFields.every(field => !!profileData[field]);
};